import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerSubCategory
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="SUBCATEGORY" disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerSubCategory
